// src/pages/dutyspace/dutyspace.js
import React from 'react'
import Viewdutyspace from '../../components/dutyspace/viewdutyspace'

export default function Dutyspace() {
  return (
     // Page container with horizontal padding using Tailwind's utility class
    <div className='sm:px-2'>
      {/*Render the Viewdutyspace component. This component likely displays duty-related information such as:
        - Inbond/Exbond summaries
        - Pending or cleared duties
        - Calculations or analytics related to customs duties */}
        <Viewdutyspace/>
    </div>
  )
}
